let label;
let imageUrl;
let description;

export default {
    colors: {
        black: {
            label: (label = 'Black'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-black.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'black',
            description: (description =
                'Standard black base material for a sophisticated look.'),
            detailsModalDescription: description,
        },
        white: {
            label: (label = 'White'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-white.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'white',
            description: (description = 'Standard white base material.'),
            detailsModalDescription: description,
        },
        brown: {
            label: (label = 'Brown'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-brown.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'brown',
            description: (description =
                'Provides a natural, organic look and feel.'),
            detailsModalDescription: description,
        },
        customWithPattern: {
            label: (label = 'Custom'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-wheel.svg'),
            detailsModalImageUrl: imageUrl,
            value: 'custom',
            description: (description =
                'Looking for more options? Create your own design using our quote tool — select a pattern or provide your own artwork design.'),
            detailsModalDescription: description,
            hideFromSelections: true,
        },
        customWithoutPattern: {
            label: (label = 'Custom'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-wheel.svg'),
            detailsModalImageUrl: imageUrl,
            value: 'custom',
            description: (description =
                'Looking for more options? Create your own design using our quote tool by providing your own artwork.'),
            detailsModalDescription: description,
            hideFromSelections: true,
        },
        customWhite: {
            label: (label = 'White'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-custom-white.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'white',
            description: (description =
                'Standard white base material allows your artwork to be crisp and bright.'),
            detailsModalDescription: description,
        },
        customBrown: {
            label: (label = 'Brown'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-custom-brown.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'brown',
            description: (description =
                'Provides a natural, organic look and feel.'),
            detailsModalDescription: description,
        },
        customClear: {
            label: (label = 'Clear'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-custom-clear.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'clear',
            description: (description =
                'Great choice if you want a window in your packaging to let your product shine through.'),
            detailsModalDescription: description,
        },
        customMetallic: {
            label: (label = 'Metallic'),
            detailsModalLabel: label,
            imageUrl: (imageUrl =
                '/images/configurator-choices/color-custom-metallic.webp'),
            detailsModalImageUrl: imageUrl,
            value: 'metallic',
            description: (description =
                'Add stunning metallic effects and dimension to the artwork on your packaging.'),
            detailsModalDescription: description,
        },
    },
    materials: {
        standard: {
            label: (label = 'Standard'),
            detailsModalLabel: label,
            value: 'standard',
            description: (description = 'Our standard, smooth base material.'),
            detailsModalDescription: description,
        },
        customStandard: {
            label: (label = 'Standard'),
            detailsModalLabel: label,
            value: 'standard',
            description: (description =
                'Standard bright white base material with a matte or gloss finish that enhances vibrant designs.'),
            detailsModalDescription: description,
        },
        kraft: {
            label: (label = 'Kraft'),
            detailsModalLabel: label,
            value: 'kraft',
            description: (description =
                'A brown kraft paper material with a high-barrier foil lining, offering a natural look and feel.'),
            detailsModalDescription: description,
        },
        compostable: {
            label: (label = 'Compostable'),
            detailsModalLabel: label,
            value: 'compostable',
            description: (description =
                'Brown or white kraft paper material with an oxygen- and moisture-resistant barrier. It is FDA-approved for food contact and has a 6-month shelf life. White kraft meets ASTM D6868 standards for industrial compostability, with testing in progress for brown kraft.'),
            detailsModalDescription: description,
        },
        holographic: {
            label: (label = 'Holographic'),
            detailsModalLabel: label,
            value: 'holographic',
            description: (description =
                'A holographic film features distinctive illumination and rainbow effects. When combined with our high-resolution digital printing process, this material creates unmatched visual impact. Offered with matte or gloss overlam.'),
            detailsModalDescription: description,
        },
        tearResistant: {
            label: (label = 'Tear Resistant'),
            detailsModalLabel: label,
            value: 'tear-resistant',
            description: (description =
                'A strong white base material with excellent barrier properties, tear-proof security, and a matte or gloss finish. A great choice for products needing child-resistant features and for heavier contents.'),
            detailsModalDescription: description,
        },
        metallic: {
            label: (label = 'Metallic'),
            detailsModalLabel: label,
            value: 'metallic',
            description: (description =
                'A holographic film features distinctive illumination and rainbow effects. When combined with our high-resolution digital printing process, this holographic material can create packaging with unmatched visual impact.'),
            detailsModalDescription: description,
        },
        evoh: {
            label: (label = 'EVOH'),
            detailsModalLabel: label,
            value: 'evoh',
            description: (description =
                'A base material with excellent barrier properties and a matte or gloss finish. This laminate does not have a metalized PET lining. Great for anything containing acid or corrosive elements, including bath salts, frozen foods, gummies and much more! White or clear option.'),
            detailsModalDescription: description,
        },
        tramadoBlanco: {
            label: 'Tramado Blanco',
            value: 'tramado-blanco',
        },
        recyclable: {
            label: (label = 'Recyclable'),
            detailsModalLabel: label,
            value: 'recyclable',
            description: (description =
                'This all-HDPE film is store drop-off recyclable (#2) and has excellent moisture and oxygen barriers. Offered in white or clear and a matte overlam smooth satin finish.'),
            detailsModalDescription: description,
        },
    },
    finishes: {
        matte: {
            label: (label = 'Matte'),
            detailsModalLabel: label,
            value: 'matte',
            description: (description =
                'A smooth satin finish that provides a more subtle and sophisticated look. This is our most popular finish selection.'),
            detailsModalDescription: description,
        },
        gloss: {
            label: (label = 'Gloss'),
            detailsModalLabel: label,
            value: 'gloss',
            description: (description =
                'A high gloss finish. This is our second most popular finish.'),
            detailsModalDescription: description,
        },
        customGloss: {
            label: (label = 'Gloss'),
            detailsModalLabel: label,
            value: 'gloss',
            description: (description =
                'A high gloss finish to give the color on your bag that extra visual pop and vibrancy. This is our second most popular finish.'),
            detailsModalDescription: description,
        },
    },
};
